import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3bb86bde&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProvidersHeader: require('/home/runner/work/webpage/webpage/components/providers/header/header.vue').default,ProvidersHowItWorks: require('/home/runner/work/webpage/webpage/components/providers/how-it-works/how-it-works.vue').default,ProvidersSpecifications: require('/home/runner/work/webpage/webpage/components/providers/specifications/specifications.vue').default,ProvidersLifestyle: require('/home/runner/work/webpage/webpage/components/providers/lifestyle/lifestyle.vue').default,ScienceOurTests: require('/home/runner/work/webpage/webpage/components/science/our-tests/our-tests.vue').default,ScienceLogos: require('/home/runner/work/webpage/webpage/components/science/logos/logos.vue').default,ProvidersVideo: require('/home/runner/work/webpage/webpage/components/providers/video/video.vue').default,ProvidersTestimonialsImage: require('/home/runner/work/webpage/webpage/components/providers/testimonials-image/testimonials-image.vue').default,ProvidersCalendly: require('/home/runner/work/webpage/webpage/components/providers/calendly/calendly.vue').default,ProvidersContactForm: require('/home/runner/work/webpage/webpage/components/providers/contact-form/contact-form.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default})
